// removed by extract-text-webpack-plugin
module.exports = {"root":"_3LmB8_3L"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Panel/Panel.css
// module id = 485
// module chunks = 0